import React from 'react'
import Footer from '../Footer'
import RogerSix from '../RogerSix'

function Roger6() {
    window.scrollTo(0,0);
    return (
        <div>
            <RogerSix/>
            <Footer/>
        </div>
    )
}

export default Roger6
